<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      label-position="right"
      label-width="160px"
      class="demo-form-inline leftpad"
      v-model="examHyperqRest"
      :rules="rules"
    >
      <el-form-item label="受检者体位:" size="mini">
        <el-radio-group v-model="examHyperqRest.posture" :disabled="disabled">
          <el-radio label="laydown">平卧位</el-radio>
          <el-radio label="halflaydown">半卧位</el-radio>
          <el-radio label="sit">坐位</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="受检者当时/近期情况:" size="mini">
        <el-radio-group v-model="examHyperqRest.situation" :disabled="disabled">
          <el-radio label="semisleeping">半睡眠</el-radio>
          <el-radio label="quiet">安静</el-radio>
          <el-radio label="speaking">说话</el-radio>
          <el-radio label="excited">激动</el-radio>
          <el-radio label="anxiety">焦虑</el-radio>
          <el-radio label="depressed">低落</el-radio>
          <el-radio label="drunk">饮酒</el-radio>
          <el-radio label="sleepless">熬夜</el-radio>
          <el-radio label="drugged">服药</el-radio>
          <el-radio label="other">其他</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="检测时平均心率：" size="mini">
        <el-input v-model="examHyperqRest.hr" :disabled="disabled">
          <template slot="append">次/分</template>
        </el-input>
      </el-form-item>

      <el-form-item label="心肌细胞缺血风险等级:" size="mini">
        <el-radio-group v-model="examHyperqRest.migrade" :disabled="disabled">
          <el-radio label="low">低风险</el-radio>
          <el-radio label="hint">提示有风险</el-radio>
          <el-radio label="middle">中度风险</el-radio>
          <el-radio label="high">高风险</el-radio>
          <el-radio label="extreme">极高风险</el-radio>
          <el-radio label="other">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="心肌细胞缺血类型:" size="mini" prop="miType">
        <el-radio-group v-model="examHyperqRest.mitype" :disabled="disabled">
          <el-radio label="organic">器质型</el-radio>
          <el-radio label="function">功能型</el-radio>
          <el-select v-model="examHyperqRest.miSubType">
            <el-option label="心脏耐力下降" value="0"></el-option>
            <el-option label="血管弹性下降" value="1"></el-option>
            <el-option label="神经功能紊乱" value="2"></el-option>
            <el-option label="内分泌功能紊乱" value="3"></el-option>
            <el-option label="脏腑气血紊乱" value="4"></el-option>
          </el-select>
          <el-radio label="hybrid">混合型</el-radio>

          <el-radio label="others">其他</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 原始Rest心电图文件 上传下载 -->

      <el-form-item label="分析产生的bsp文件:" size="mini">
        <div v-if="examHyperqRest.bspFile !== ''">
          <el-row class="el-row" type="flex">
            <a
              style="width: 100%"
              :href="examHyperqRest.bspFile"
              :disabled="ecgDisabled"
              v-if="examHyperqRest.bspFile"
              target="_blank"
            >
              {{ examHyperqRest.bspFile }}
            </a>
          </el-row>
        </div>
        <el-upload
          class="upload-demo"
          :action="upload4Cospath('bsp')"
          :on-preview="handlePreview"
          accept="*"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="uploadSuccess"
          :limit="1"
          :on-exceed="handleExceed"
          :auto-upload="true"
          :file-list="fileList"
        >
          <el-button style="margin: 0px 0px 0px 12px" size="mini" type="primary"
            >点击上传</el-button
          >
        </el-upload>
      </el-form-item>

      <el-form-item label="静息HyperQ检测报告:" size="mini">
        <div v-if="examHyperqRest.restHyperqFile !== ''">
          <el-row class="el-row" type="flex">
            <a
              style="width: 100%"
              :href="examHyperqRest.restHyperqFile"
              v-if="examHyperqRest.restHyperqFile"
              target="_blank"
            >
              {{ examHyperqRest.restHyperqFile }}
            </a>
            <el-button
              type="primary"
              v-if="examHyperqRest.restHyperqFile"
              class="button-color"
              @click="showPdf($event, 'hyperqRef')"
              >展开</el-button
            >
          </el-row>
          <div>
            <embed
              ref="hyperqRef"
              :src="examHyperqRest.restHyperqFile"
              width="100%"
              height="600px"
              style="display: none"
            />
          </div>
        </div>
        <el-upload
          class="upload-demo"
          :action="upload4Cospath('pdf')"
          :on-preview="handlePreview"
          accept="application/pdf"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="uploadSuccess"
          :limit="1"
          :on-exceed="handleExceed"
          :auto-upload="true"
          :file-list="fileList"
        >
          <el-button style="margin: 0px 0px 0px 12px" size="mini" type="primary"
            >点击上传</el-button
          >
        </el-upload>
      </el-form-item>
    </el-form>

    <el-form :disabled="disabled">
      <!-- HyperQ 自定义结构表格 -表头 -->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">\&nbsp;</el-col>
            <el-col :span="12">总数</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2"> I </el-col>
            <el-col :span="2"> II </el-col>
            <el-col :span="2"> III </el-col>
            <el-col :span="2"> aVR </el-col>
            <el-col :span="2"> aVL </el-col>
            <el-col :span="2"> aVF </el-col>
            <el-col :span="2"> V1 </el-col>
            <el-col :span="2"> V2 </el-col>
            <el-col :span="2"> V3 </el-col>
            <el-col :span="2"> V4 </el-col>
            <el-col :span="2"> V5 </el-col>
            <el-col :span="2"> V6 </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- HyperQ 自定义结构表格 -第一行 阳性-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">阳性</el-col>
            <el-col :span="12">{{ examHyperqRest.totalPositive }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isipositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiiPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvrPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvlPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvfPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv1positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv2positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv3positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv4positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv5positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv6positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- HyperQ 自定义结构表格 -第二行 临界-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">临界</el-col>
            <el-col :span="12">{{ examHyperqRest.totalBorderline }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isiborderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiiBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvrBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvlBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvfBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv1borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv2borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv3borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv4borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv5borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv6borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row> </el-col
      ></el-row>

      <!-- HyperQ 自定义结构表格 -第三行 异常-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">异常</el-col>
            <el-col :span="12">{{ examHyperqRest.totalException }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isiexception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isIiiException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvrException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvlException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isAvfException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv1exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv2exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv3exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv4exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv5exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperqRest.isv6exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row> </el-col
      ></el-row>

      <!-- HyperQ 自定义结构表格 -第四行-电压 -->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">电压（振幅）</el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.iVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.iiVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.iiiVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.avrVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.avlVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.avfVoltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v1voltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v2voltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v3voltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v4voltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v5voltage">
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-input class="small-input" v-model="examHyperqRest.v6voltage">
              </el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">波形</el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iiWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iiiWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avrWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avlWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avfWaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v1WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v2WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v3WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v4WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v5WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v6WaveType" placeholder=".">
                <el-option
                  v-for="item in restWaveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="8">高频波形指数</el-col>
            <el-col :span="8"></el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iiRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.iiiRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avrRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avlRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.avfRaz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v1raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v2raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v3raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v4raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v5raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="examHyperqRest.v6raz" placeholder=".">
                <el-option
                  v-for="item in razIndex"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="30" style="margin-top: 20px">
      <el-col :span="24" class="alignCenter">
        <el-button
          :loading="submitting"
          type="primary"
          size="medium"
          @click="_updateExamHyperqRest"
          class="fullWidth"
          v-show="true"
          :disabled="
            examHyperqRest.mitype === '' ||
            examHyperqRest.bspFile === '' ||
            examHyperqRest.restHyperqFile === ''
          "
          >保存</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { baseURL } from "../../api/axiosCreator";
import {
  getExamHyperqRest,
  updateExamHyperqRest,
} from "../../api/userExamService";
import { waveOptions, restWaveOptions, razIndex } from "../../utils/constants";
export default {
  name: "HyperQRest",
  props: {
    examUuid: String,
    disabled: Boolean,
    hyperqDisabled: Boolean,
  },
  data() {
    return {
      fileList: [],
      hyperQShow: false,
      ecgDisabled: false,
      submitting: false,
      upload_pdf_file: "",
      upload_bsp_file: "",
      hyperQFileUrl: "",
      bspFileUrl: "",
      dialogVisible: false,
      restHyperQShow: false,
      //HyperQRest检查
      examHyperqRest: {
        examUuid: "",
        posture: "",
        situation: "",
        hr: "",
        migrade: "",
        mitype: "",
        miSubType: "",
        rawRestFile: "",
        bspFile: "",
        restHyperqFile: "",
        isAvfBorderline: false,
        isAvfException: false,
        isAvfPositive: false,
        isAvlBorderline: false,
        isAvlException: false,
        isAvlPositive: false,
        isAvrBorderline: false,
        isAvrException: false,
        isAvrPositive: false,
        isiborderline: false,
        isiexception: false,
        isipositive: false,
        isIiBorderline: false,
        isIiException: false,
        isIiPositive: false,
        isIiiBorderline: false,
        isIiiException: false,
        isIiiPositive: false,
        isv1borderline: false,
        isv1exception: false,
        isv1positive: false,
        isv2borderline: false,
        isv2exception: false,
        isv2positive: false,
        isv3borderline: false,
        isv3exception: false,
        isv3positive: false,
        isv4borderline: false,
        isv4exception: false,
        isv4positive: false,
        isv5borderline: false,
        isv5exception: false,
        isv5positive: false,
        isv6borderline: false,
        isv6exception: false,
        isv6positive: false,
        avfVoltage: "",
        avlVoltage: "",
        avrVoltage: "",
        iVoltage: "",
        iiVoltage: "",
        iiiVoltage: "",
        v1voltage: "",
        v2voltage: "",
        v3voltage: "",
        v4voltage: "",
        v5voltage: "",
        v6voltage: "",
        avfWaveType: "",
        avlWaveType: "",
        avrWaveType: "",
        iWaveType: "",
        iiWaveType: "",
        iiiWaveType: "",
        v1waveType: "",
        v2waveType: "",
        v3waveType: "",
        v4waveType: "",
        v5waveType: "",
        v6waveType: "",
        avfRaz: "",
        avlRaz: "",
        avrRaz: "",
        iRaz: "",
        iiRaz: "",
        iiiRaz: "",
        v1raz: "",
        v2raz: "",
        v3raz: "",
        v4raz: "",
        v5raz: "",
        v6raz: "",
        totalBorderline: 0,
        totalException: 0,
        totalPositive: 0,
        ivoltage: "",
        iwaveType: "",
        iraz: "",
      },
      HyperQp: "",
      HyperQn: "",
      //波形选项
      waveOptions: waveOptions,
      restWaveOptions: restWaveOptions,
      razIndex: razIndex,
      initialized: false,
      rules: {
        miType: [{ required: true, message: "请选择", trigger: "blur" }],
        rawRestFile: [
          { required: true, message: "请上传原始文件", trigger: "blur" },
        ],
        bspFile: [
          { required: true, message: "请上传bsp文件", trigger: "blur" },
        ],
        restHyperqFile: [
          { required: true, message: "请上传pdf文件", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    examHyperqRest: {
      handler: function () {
        // console.log(val)
      },
      deep: true,
    },
    "examHyperqRest.isipositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isiborderline = false;
        this.examHyperqRest.isiexception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isiborderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isipositive = false;
        this.examHyperqRest.isiexception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isiexception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isipositive = false;
        this.examHyperqRest.isiborderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    //ii
    "examHyperqRest.isIiPositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiBorderline = false;
        this.examHyperqRest.isIiException = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isIiBorderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiPositive = false;
        this.examHyperqRest.isIiException = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isIiException": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiPositive = false;
        this.examHyperqRest.isIiBorderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //iii
    "examHyperqRest.isIiiPositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiiBorderline = false;
        this.examHyperqRest.isIiiException = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isIiiBorderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiiPositive = false;
        this.examHyperqRest.isIiiException = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isIiiException": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isIiiPositive = false;
        this.examHyperqRest.isIiiBorderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //avr
    "examHyperqRest.isAvrPositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvrBorderline = false;
        this.examHyperqRest.isAvrException = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isAvrBorderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvrPositive = false;
        this.examHyperqRest.isAvrException = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isAvrException": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvrPositive = false;
        this.examHyperqRest.isAvrBorderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //avl
    "examHyperqRest.isAvlPositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvlBorderline = false;
        this.examHyperqRest.isAvlException = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isAvlBorderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvlPositive = false;
        this.examHyperqRest.isAvlException = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isAvlException": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvlPositive = false;
        this.examHyperqRest.isAvlBorderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //avf
    "examHyperqRest.isAvfPositive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvfBorderline = false;
        this.examHyperqRest.isAvfException = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isAvfBorderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvfPositive = false;
        this.examHyperqRest.isAvfException = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isAvfException": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isAvfPositive = false;
        this.examHyperqRest.isAvfBorderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //v1
    "examHyperqRest.isv1positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv1borderline = false;
        this.examHyperqRest.isv1exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv1borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv1positive = false;
        this.examHyperqRest.isv1exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv1exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv1positive = false;
        this.examHyperqRest.isv1borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //v2
    "examHyperqRest.isv2positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv2borderline = false;
        this.examHyperqRest.isv2exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv2borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv2positive = false;
        this.examHyperqRest.isv2exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv2exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv2positive = false;
        this.examHyperqRest.isv2borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //v3
    "examHyperqRest.isv3positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv3borderline = false;
        this.examHyperqRest.isv3exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv3borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv3positive = false;
        this.examHyperqRest.isv3exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv3exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv3positive = false;
        this.examHyperqRest.isv3borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //v4
    "examHyperqRest.isv4positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv4borderline = false;
        this.examHyperqRest.isv4exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv4borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv4positive = false;
        this.examHyperqRest.isv4exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv4exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv4positive = false;
        this.examHyperqRest.isv4borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException--;
    },
    //v5
    "examHyperqRest.isv5positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv5borderline = false;
        this.examHyperqRest.isv5exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv5borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv5positive = false;
        this.examHyperqRest.isv5exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv5exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv5positive = false;
        this.examHyperqRest.isv5borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
    //v6
    "examHyperqRest.isv6positive": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv6borderline = false;
        this.examHyperqRest.isv6exception = false;
      }
      val
        ? this.examHyperqRest.totalPositive++
        : this.examHyperqRest.totalPositive>0?this.examHyperqRest.totalPositive--:this.examHyperqRest.totalPositive;
    },
    "examHyperqRest.isv6borderline": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv6positive = false;
        this.examHyperqRest.isv6exception = false;
      }
      val
        ? this.examHyperqRest.totalBorderline++
        : this.examHyperqRest.totalBorderline>0?this.examHyperqRest.totalBorderline--:this.examHyperqRest.totalBorderline;
    },
    "examHyperqRest.isv6exception": function (val) {
      if (val === null) return;
      if (val) {
        this.examHyperqRest.isv6positive = false;
        this.examHyperqRest.isv6borderline = false;
      }
      val
        ? this.examHyperqRest.totalException++
        : this.examHyperqRest.totalException>0?this.examHyperqRest.totalException--:this.examHyperqRest.totalException;
    },
  },
  methods: {
    showPdf(e, ref) {
      let isHidden = this.$refs[ref].style.display == "none";
      if (isHidden) {
        this.$refs[ref].style.display = "block";
        e.currentTarget.textContent = "折叠";
      } else {
        this.$refs[ref].style.display = "none";
        e.currentTarget.textContent = "展开";
      }
    },
    _getExamHyperqRest() {
      let self = this;
      getExamHyperqRest(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            // this.initialized = false;
            self.examHyperqRest.examUuid = res.data[0].examUuid;
            self.examHyperqRest.posture = res.data[0].posture;
            self.examHyperqRest.situation = res.data[0].situation;
            self.examHyperqRest.hr = res.data[0].hr;
            self.examHyperqRest.migrade = res.data[0].migrade;
            self.examHyperqRest.mitype = res.data[0].mitype?res.data[0].mitype.split("^")[0]:'';
            self.examHyperqRest.miSubType = res.data[0].mitype?res.data[0].mitype.split("^")[1]:'';
            self.examHyperqRest.rawRestFile = res.data[0].rawRestFile;
            self.examHyperqRest.bspFile = res.data[0].bspFile;
            self.examHyperqRest.restHyperqFile = res.data[0].restHyperqFile;
            self.examHyperqRest.isAvfBorderline = res.data[0].isAvfBorderline;
            self.examHyperqRest.isAvfException = res.data[0].isAvfException;
            self.examHyperqRest.isAvfPositive = res.data[0].isAvfPositive;
            self.examHyperqRest.isAvlBorderline = res.data[0].isAvlBorderline;
            self.examHyperqRest.isAvlException = res.data[0].isAvlException;
            self.examHyperqRest.isAvlPositive = res.data[0].isAvlPositive;
            self.examHyperqRest.isAvrBorderline = res.data[0].isAvrBorderline;
            self.examHyperqRest.isAvrException = res.data[0].isAvrException;
            self.examHyperqRest.isAvrPositive = res.data[0].isAvrPositive;
            self.examHyperqRest.isiborderline = res.data[0].isiborderline;
            self.examHyperqRest.isiexception = res.data[0].isiexception;
            self.examHyperqRest.isipositive = res.data[0].isipositive;
            self.examHyperqRest.isIiBorderline = res.data[0].isIiBorderline;
            self.examHyperqRest.isIiException = res.data[0].isIiException;
            self.examHyperqRest.isIiPositive = res.data[0].isIiPositive;
            self.examHyperqRest.isIiiBorderline = res.data[0].isIiiBorderline;
            self.examHyperqRest.isIiiException = res.data[0].isIiiException;
            self.examHyperqRest.isIiiPositive = res.data[0].isIiiPositive;
            self.examHyperqRest.isv1borderline = res.data[0].isv1borderline;
            self.examHyperqRest.isv1exception = res.data[0].isv1exception;
            self.examHyperqRest.isv1positive = res.data[0].isv1positive;
            self.examHyperqRest.isv2borderline = res.data[0].isv2borderline;
            self.examHyperqRest.isv2exception = res.data[0].isv2exception;
            self.examHyperqRest.isv2positive = res.data[0].isv2positive;
            self.examHyperqRest.isv3borderline = res.data[0].isv3borderline;
            self.examHyperqRest.isv3exception = res.data[0].isv3exception;
            self.examHyperqRest.isv3positive = res.data[0].isv3positive;
            self.examHyperqRest.isv4borderline = res.data[0].isv4borderline;
            self.examHyperqRest.isv4exception = res.data[0].isv4exception;
            self.examHyperqRest.isv4positive = res.data[0].isv4positive;
            self.examHyperqRest.isv5borderline = res.data[0].isv5borderline;
            self.examHyperqRest.isv5exception = res.data[0].isv5exception;
            self.examHyperqRest.isv5positive = res.data[0].isv5positive;
            self.examHyperqRest.isv6borderline = res.data[0].isv6borderline;
            self.examHyperqRest.isv6exception = res.data[0].isv6exception;
            self.examHyperqRest.isv6positive = res.data[0].isv6positive;
            self.examHyperqRest.avfVoltage = res.data[0].avfVoltage;
            self.examHyperqRest.avlVoltage = res.data[0].avlVoltage;
            self.examHyperqRest.avrVoltage = res.data[0].avrVoltage;
            self.examHyperqRest.iVoltage = res.data[0].iVoltage;
            self.examHyperqRest.iiVoltage = res.data[0].iiVoltage;
            self.examHyperqRest.iiiVoltage = res.data[0].iiiVoltage;
            self.examHyperqRest.v1voltage = res.data[0].v1voltage;
            self.examHyperqRest.v2voltage = res.data[0].v2voltage;
            self.examHyperqRest.v3voltage = res.data[0].v3voltage;
            self.examHyperqRest.v4voltage = res.data[0].v4voltage;
            self.examHyperqRest.v5voltage = res.data[0].v5voltage;
            self.examHyperqRest.v6voltage = res.data[0].v6voltage;
            self.examHyperqRest.avfWaveType = res.data[0].avfWaveType;
            self.examHyperqRest.avlWaveType = res.data[0].avlWaveType;
            self.examHyperqRest.avrWaveType = res.data[0].avrWaveType;
            self.examHyperqRest.iWaveType = res.data[0].iWaveType;
            self.examHyperqRest.iiWaveType = res.data[0].iiWaveType;
            self.examHyperqRest.iiiWaveType = res.data[0].iiiWaveType;
            self.examHyperqRest.v1waveType = res.data[0].v1waveType;
            self.examHyperqRest.v2waveType = res.data[0].v2waveType;
            self.examHyperqRest.v3waveType = res.data[0].v3waveType;
            self.examHyperqRest.v4waveType = res.data[0].v4waveType;
            self.examHyperqRest.v5waveType = res.data[0].v5waveType;
            self.examHyperqRest.v6waveType = res.data[0].v6waveType;
            self.examHyperqRest.avfRaz = res.data[0].avfRaz;
            self.examHyperqRest.avlRaz = res.data[0].avlRaz;
            self.examHyperqRest.avrRaz = res.data[0].avrRaz;
            self.examHyperqRest.iRaz = res.data[0].iRaz;
            self.examHyperqRest.iiRaz = res.data[0].iiRaz;
            self.examHyperqRest.iiiRaz = res.data[0].iiiRaz;
            self.examHyperqRest.v1raz = res.data[0].v1raz;
            self.examHyperqRest.v2raz = res.data[0].v2raz;
            self.examHyperqRest.v3raz = res.data[0].v3raz;
            self.examHyperqRest.v4raz = res.data[0].v4raz;
            self.examHyperqRest.v5raz = res.data[0].v5raz;
            self.examHyperqRest.v6raz = res.data[0].v6raz;
            self.examHyperqRest.totalBorderline = 0;
            self.examHyperqRest.totalException = 0;
            self.examHyperqRest.totalPositive = 0;
            self.examHyperqRest.ivoltage = res.data[0].ivoltage;
            self.examHyperqRest.iwaveType = res.data[0].iwaveType;
            self.examHyperqRest.iraz = res.data[0].iraz;

            self.initialized = true;
          }
        } else {
          this.$message({
            message: res.description,
            type: "warning",
          });
        }
      });
    },
    //更新HyperQ检查
    _updateExamHyperqRest() {
      // 序列化反序列化法
      function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
      }

      this.submitting = true;
      let temp = deepClone(this.examHyperqRest);
      temp.mitype =
        temp.mitype + (temp.miSubType != null ? "^" + temp.miSubType : "");
      updateExamHyperqRest(temp)
        .then((res) => {
          this.submitting = false;
          this.$message({
            message: res.description,
            type: res.success ? "success" : "warning",
          });
        })
        .catch((e) => {
          this.submitting = false;
          console.log(e);
        });
    },

    isCorrectFileType(fileName, type) {
      return fileName.match(type);
    },

    submitUploadRest() {
      this.$refs.uploadRest.submit();
    },
    submitUploadBsp() {
      this.$refs.uploadBsp.submit();
    },
    submitUploadPdf() {
      this.$refs.uploadPdf.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    uploadSuccess(res) {
      function confirmEnding(str, target) {
        var start = str.length - target.length;
        var arr = str.substr(start, target.length);
        if (arr == target) {
          return true;
        }
        return false;
      }

      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        this.fileList.pop();
        let url = res.data[0];
        let isRawdata = confirmEnding(url, "zip");
        if (isRawdata) {
          this.examHyperqRest.rawRestFile = url;
          return;
        }

        let isPdf = confirmEnding(url, "pdf");
        if (isPdf) {
          this.examHyperqRest.restHyperqFile = url;
          return;
        }

        let isBsp = confirmEnding(url, "bsp");
        if (isBsp) {
          this.examHyperqRest.bspFile = url;
          return;
        }
      } else {
        this.$message.error("上传失败，请重新上传");
      }
    },
    uploadError() {
      this.$refs.upload.clearFiles();
      this.$message.error("上传失败，请重新上传");
    },
  },
  computed: {
    upload4Cospath() {
      return (type) => {
        return (
          baseURL +
          "/ExamService/uploadFile4Cos/" +
          this.examUuid +
          "/" +
          type +
          "/" +
          true
        );
      };
    },
  },
  created() {
    this.examHyperqRest.examUuid = this.examUuid;
    this._getExamHyperqRest();
  },

  mounted() {
    this.$EventBus.$on("ecgFileUploadedRest", () => {
      this._getExamHyperqRest();
      //this.$message.error("updated");
    });
 }
};
</script>

<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.no-margin {
  margin-bottom: 0;
}
/* .el-row:last-child {
  margin-bottom: 0;
} */

.el-col {
  border-radius: 4px;
}

.shortInput {
  width: 40px;
}

.mediumInput {
  width: 80px;
}

.longInput {
  width: 200px;
}

.leftpad {
  padding-left: 30px;
}

.alignCenter {
  text-align: center;
}
.alignRight {
  text-align: right;
}
.fullWidth {
  width: 100%;
}
</style>